const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.293"
      height="22.653"
      viewBox="0 0 26.293 22.653"
    >
      <g id="Group_9446" data-name="Group 9446" transform="translate(0)">
        <path
          id="Path_12168"
          data-name="Path 12168"
          d="M25.888,7.984H.4a.4.4,0,0,1-.4-.4V2.9A2.9,2.9,0,0,1,2.9,0H23.389a2.9,2.9,0,0,1,2.9,2.9V7.579a.4.4,0,0,1-.4.4"
          transform="translate(0 -0.001)"
          fill="#707070"
        />
        <path
          id="Path_12169"
          data-name="Path 12169"
          d="M8.422,17.335h-5.6A2.822,2.822,0,0,1,0,14.514V5.062a.406.406,0,0,1,.4-.4H8.422a.406.406,0,0,1,.4.4V16.93a.4.4,0,0,1-.4.4"
          transform="translate(0 5.317)"
          fill="#707070"
        />
        <path
          id="Path_12170"
          data-name="Path 12170"
          d="M17.447,17.335H5.662a.4.4,0,0,1-.4-.4V5.062a.406.406,0,0,1,.4-.4h14.2a.406.406,0,0,1,.4.4v9.452a2.822,2.822,0,0,1-2.821,2.821"
          transform="translate(6.004 5.317)"
          fill="#707070"
        />
      </g>
    </svg>
  )
}

export default DashboardIcon
